import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import config from '../../config';

const LOCAL_LICENSE_REGISTER_API = `${config.backendUrl}/api/local-license/register`;
const LOCAL_LICENSE_STATUS_API = `${config.backendUrl}/api/local-license/status`;

export default function LocalLicenseSetting() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const [message, setMessage] = useState('');

  const applyStatus = (data) => {
    const verified = data.license_status === 'permanently_unlocked' || Boolean(data.is_permanently_unlocked);
    if (data.is_registered) {
      setIsRegistered(true);
      setIsVerified(verified);
      setMessage(
        verified
          ? '라이센스 검증 완료'
          : `등록 완료 (시작: ${data.license_started_at || '-'}, 만료: ${data.license_expires_at || '-'})`
      );
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await axios.get(LOCAL_LICENSE_STATUS_API);
      const data = response.data || {};
      applyStatus(data);
    } catch (error) {
      console.error('Failed to fetch local license status.', error);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const handleRegister = async () => {
    if (isRegistered || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setMessage('');

    try {
      const response = await axios.post(LOCAL_LICENSE_REGISTER_API, {});
      const data = response.data || {};
      setIsRegistered(true);
      setMessage(
        `등록 완료 (시작: ${data.license_started_at || '-'}, 만료: ${data.license_expires_at || '-'})`
      );
    } catch (error) {
      const statusCode = error?.response?.status;
      const errorMessage = error?.response?.data?.message || error?.response?.data?.error || '로컬 라이센스 등록에 실패했습니다.';
      if (statusCode === 409) {
        setIsRegistered(true);
        await fetchStatus();
      }
      setMessage(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-wrap align-items-center gap-3">
      <Button
        variant="primary"
        onClick={handleRegister}
        disabled={isSubmitting || isRegistered}
      >
        {isSubmitting ? '등록 중...' : isVerified ? '라이센스 검증 완료' : isRegistered ? '등록 완료' : '로컬 라이센스 등록'}
      </Button>
      {message && <span className="text-muted">{message}</span>}
    </div>
  );
}
